function ScheduleCalculator()
{
    this.constructor= ScheduleCalculator;
}

ScheduleCalculator.prototype.init = function ( invertedDaysMap,  userSchedules )
{
    if( !userSchedules || userSchedules.length == 0 )
        throw "ScheduleCalculator: Illegal arguments exception";

    this.userSchedules = userSchedules;

    if(invertedDaysMap){
        this.invertedDaysYearMap =  invertedDaysMap["map"] ?  invertedDaysMap["map"] : {};
    }else
        this.invertedDaysYearMap = {};

    return this;
};

/**
 * @param {Date} fromDate
 * @param {Date} toDate
 * @return {Array} array of boolean; true = working day, false = nonworking day
 */
ScheduleCalculator.prototype.getEffectiveSchedule = function ( fromDate, toDate )
{
    fromDate = fromDate.truncateTime();
    toDate = toDate.truncateTime();

    var result = [];
    var durations = this.userSchedules[0].durations;
    var nextScheduleIdx = 1;
    var nextSchedule = this.userSchedules[nextScheduleIdx];
    var lastDateTo = fromDate;

    while( nextSchedule )
    {
        var nextEffectiveDate = nextSchedule.effectiveDate.parseJSONDate();
        if( nextEffectiveDate > toDate )
            break;

        if( nextEffectiveDate > fromDate )
        {
            lastDateTo = nextEffectiveDate;
            this._processDurations( result, fromDate, lastDateTo, durations );
            fromDate = lastDateTo;
        }
        durations = nextSchedule.durations;
        nextSchedule = this.userSchedules[++nextScheduleIdx];
    }

    if( lastDateTo < toDate )
        this._processDurations( result, lastDateTo, toDate.nextDay(), durations );

    return result;
};

ScheduleCalculator.prototype._processDurations = function( scheduleArray, fromDate, toDate, durations )
{
    var d;
    var invertedDay;

    for(var i = new window.DatesIterator( fromDate, toDate.prevDay() ); i.hasNext(); )
    {
        d = i.next();
        invertedDay = this._getInvertedDay( d );

        if(invertedDay)
            scheduleArray.push( invertedDay.isWorking );
        else
            scheduleArray.push( durations[ d.getDay() ] > 0 );
    }
};

ScheduleCalculator.prototype._getInvertedDay = function ( date ) {
    // working days and days off
    var invertedDaysYear = this.invertedDaysYearMap[String( date.getFullYear() )];
    if( typeof(invertedDaysYear) != typeof(undefined) )
    {
        var invertedDaysMonthMap = invertedDaysYear["map"];
        if( typeof(invertedDaysMonthMap) != typeof(undefined) )
        {
            var invertedDaysMonthSet = invertedDaysMonthMap[String( date.getMonth() )];
            if( typeof(invertedDaysMonthSet) != typeof(undefined) )
            {
                var invertedDaysMonth = invertedDaysMonthSet["map"];
                if( typeof(invertedDaysMonth[date.getDate()]) != typeof(undefined) )
                {
                    return  {
                        isWorking: invertedDaysMonth[date.getDate()] == "WORKING"
                    };

                }
            }
        }
    }

    return false;
};

export default ScheduleCalculator



// WEBPACK FOOTER //
// ./web/js/controls/dateControls/ScheduleCalculator.js